import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from 'redux/store';
import ErrorBoundary from 'features/ErrorBoundary/ErrorBoundary';
import App from './App';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import './index.css';
import { createTheme, Input, MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import classes from './Input.module.scss';
dayjs.locale('ru');
import { initMetrika } from './utils/metrika';

const theme = createTheme({
  focusRing: 'never',
  fontFamily: 'Inter, sans-serif',
  cursorType: 'pointer',
  components: {
    Input: Input.extend({ classNames: classes }),
  },
});
initMetrika();

const root = ReactDOM.createRoot(document.getElementById('root_admin') as HTMLElement);
root.render(
  <Provider store={store}>
    <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
      <MantineProvider theme={theme}>
        <ErrorBoundary>
          <DatesProvider settings={{ locale: 'ru', consistentWeeks: true }}>
            <App />
          </DatesProvider>
        </ErrorBoundary>
      </MantineProvider>
    </BrowserRouter>
  </Provider>,
);
